import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {gettextCatalog} from "angular-gettext";
import {Kontekst} from "felles/tjenester/Kontekst";
import {IntroJsTjeneste} from "felles/tjenester/IntroJs";
import {Debugger} from "debug";
import {StateService} from "@uirouter/angularjs";

const debug: Debugger = require('debug')('ArkivKontroller');

/**
 * Kontroller for arkiv.
 */
export class ArkivKontroller {
    static regNavn = "arkivKontroller";
    static forInjisering = () => {
        return [
            regNavn.ng.ui.$state,
            regNavn.gettext.gettextCatalog,
            IntroJsTjeneste.regNavn,
            Kontekst.regNavn,
            ArkivKontroller
        ]
    };

    constructor(protected $state: StateService,
                private gettextCatalog: gettextCatalog,
                private introJs: IntroJsTjeneste,
                private kontekst: Kontekst) {
    }

    sti: l.ArkivMappenodeModell[] = [];
    filer: l.ArkivFilnodeModell[] = [];

    //hjelpemetoder

    private initIntroJs() {
        this.kontekst.erLastetFraServer().then(() => {
              const harSkriveTilgang = this.kontekst.inneharTilgangsrolleINoenGruppe(l.TilgangsrolleMedlem.skrive)
              this.introJs.visIntroForsinket(
                this.introJs.nyIntroduksjon('arkiv')
                  .leggTilSteg(
                    1,
                    {
                        title: this.gettextCatalog.getString('Biblioteket'),
                        intro: this.gettextCatalog.getString('Hver gruppe har sitt eget bibliotek. Klikk deg inn på en gruppe for å administrere mapper og dokumenter.'),
                    },
                    () => harSkriveTilgang  && this.sti.length == 0
                  )
                  .leggTilSteg(
                    2,
                    {
                        title: this.gettextCatalog.getString('Biblioteket'),
                        intro: this.gettextCatalog.getString('Dette er biblioteket til gruppene dine. Her kan administrator laste opp dokumenter.'),
                    },
                    () => !harSkriveTilgang && this.sti.length == 0
                  )
                  .leggTilSteg(
                    3,
                    {
                        title: this.gettextCatalog.getString('Biblioteksmeny'),
                        intro: this.gettextCatalog.getString('I biblioteksmenyen redigerer du mapper, styrer tilganger, og du kan importere mapper fra egen maskin (.zip).'),
                        element: '[data-tips-id="komponent-meny"]',
                        position: "left"
                    },
                    () => this.sti.length > 1
                  )
                  .leggTilSteg(
                    4,
                    {
                        title: this.gettextCatalog.getString('Laste opp dokumenter'),
                        intro: this.gettextCatalog.getString('Bruk plussikonet for å laste opp dokumenter og opprette mapper.'),
                        element: '[data-tips-id="arkiv-leggtil"]',
                        position: "right"
                    },
                    () => this.sti.length > 1 && harSkriveTilgang
                  )
                  .leggTilSteg(
                    5,
                    {
                        title: this.gettextCatalog.getString('Dokumentmeny'),
                        intro: this.gettextCatalog.getString('Her kan du redigere tilgang og sende dokumenter til signering.'),
                        element: '[data-tips-id="arkiv-dokumentmeny"]',
                        position: "right"
                    },
                    () => this.filer.length > 0 && harSkriveTilgang
                  ),
                1000
              );
          }
        );
    }

}
